<template>
  <section class="selftests">
    <div class="response_table" >
      <table>
        <thead>
          <tr>
            <th scope="col"> ID </th>
            <th scope="col"> Server </th>
            <th scope="col"> Username </th>
            <th scope="col"> Ifaces </th>
            <th scope="col"> Speed (Mb/s) </th>
            <th scope="col"> Description </th>
            <th scope="col"> TS </th>
            <th scope="col"> Duration </th>
            <th scope="col"> Status </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(elem_test, elem_test_key) in selftest_list" :key="elem_test_key" @click="show_modal(elem_test)">
            <td data-label="ID" >
              {{elem_test.id}}
            </td>
            <td data-label="Server" >
              {{elem_test.server}}
            </td>
            <td data-label="Username" >
              {{elem_test.user_name}}
            </td>
            <td data-label="Ifaces" >
              {{elem_test.ifaces}}
            </td>
            <td data-label="Speed" >
              {{elem_test.short_result}}
            </td>
            <td data-label="Description" >
              {{elem_test.descr}}
            </td>
            <td data-label="TS" >
              {{get_date(elem_test.ts)}}
            </td>
            <td data-label="Duration" >
              {{elem_test.duration}}
            </td>
            <td data-label="Status" >
              {{elem_test.status}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import SelfTestsModal from './Modal/Index.vue'

export default {
  name: 'SelfTestsList',
  props: ['device_id'],

  data(){
    return {
      selftest_list: {},
      check_link: true,
    }
  },
  created() {
    this.init()
  },
  methods: {
    check_selftest() {
      if (this.$route.query.selftest_id) {
        this.selftest_list.forEach((selftest_item) => {
          if (selftest_item.id === Number(this.$route.query.selftest_id)){
            this.show_selftest(selftest_item);
          }
        })
      }
    },
    show_selftest(val) {
      if (this.$route.params.device_section === "testing") {
        if (this.check_link) {
          this.check_link = false;
          this.show_modal(val);
        }
      }
    },
    show_modal(data){
      let t = this.$createElement(SelfTestsModal, {
        props: {
          type: 'selftest_list',
          data
        },
        on: {
          close: () => {
            this.$modal.hide('show_selftest')
            this.check_link = true;
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'show_selftest'})
    },
    init(){
      this.$http.v1.getDeviceSelfTestList( {device_id: this.device_id}, (response) => {
        this.selftest_list = response.data.selftest_list
        this.check_selftest()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  section.selftests{
    display: flex;
    .response_table{
      padding: 0;
      .title{
        text-align: center;
        margin-top: 10px;
      }
      th{
        font-size: 12px;
      }
      tbody{
        tr{
          cursor: pointer;
          font-size: 12px;
          &:hover{
            background-color: #f1f1f1;
          }
        }
      }
    }
  }
</style>
